export default __webpack_public_path__ + "static/media/arrow_left.cfd1df3e.svg";